import React from "react";
import clsx from "clsx";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { CustomCard } from "../../../../../Components";

import useStyles from "./styles";

function ClientProfileSkeletonLoader() {
  const styles = useStyles();
  return (
    <Box>
      <CustomCard className={clsx(styles.cardStyle, styles.cardHeading)}>
        <Box className={styles.agentContainer}>
          <Skeleton
            variant="circle"
            width={56}
            height={56}
            className={styles.agentAvatarSkeleton}
          />
          <Box className={styles.clientData} width={"70%"}>
            <Skeleton variant="text" width="30%" height={20} />
            <Box className={styles.clientDetailsSkeleton}>
              <Skeleton variant="text" width="30%" height={20} />
              <Skeleton variant="rect" width={20} height={20} />
              <Skeleton variant="text" width="30%" height={20} />
              <Skeleton variant="rect" width={20} height={20} />
            </Box>
            <Box className={styles.socialIcons}>
              <Skeleton variant="circle" width={20} height={20} />
              <Skeleton variant="circle" width={20} height={20} />
              <Skeleton variant="circle" width={20} height={20} />
              <Skeleton variant="circle" width={20} height={20} />
            </Box>
            <Skeleton variant="text" width="60%" height={20} />
          </Box>
        </Box>
      </CustomCard>
      <Box className={styles.summarySection}>
        <Box className={styles.titleHeading}>
          <Skeleton variant="text" width="90px" height={40} />
        </Box>
        <Box width={"70%"} className={styles.profileField}>
          <Skeleton variant="text" width="40%" height={20} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
        <Box width={"70%"} className={styles.profileField}>
          <Skeleton variant="text" width="40%" height={20} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
        <Box width={"70%"} className={styles.profileField}>
          <Skeleton variant="text" width="40%" height={20} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
      </Box>
    </Box>
  );
}

export default ClientProfileSkeletonLoader;
